import Component from "./certificates.component";
import { Config } from "./certificates.config";
import { watchCertificates as saga } from "./redux/certificates.sagas";
import { reducer } from "./redux/certificates.reducer";

export default { Component, saga, reducer, config: Config };
